import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import 'assets/css/App.css';
import { Route, Switch, Redirect } from 'react-router-dom';
import AuthLayout from 'layouts/auth';
import AdminLayout from 'layouts/admin';
import RtlLayout from 'layouts/rtl';
import { ChakraProvider, Flex, Spinner, useToast } from '@chakra-ui/react';
import theme from 'theme/theme';
import { ThemeEditorProvider } from '@hypertheme-editor/chakra-ui';
import axios from 'axios';
import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<ChakraProvider theme={theme}>
		<React.StrictMode>
			<ThemeEditorProvider>
				<BrowserRouter>
					<AppRoutes />
				</BrowserRouter>
			</ThemeEditorProvider>
		</React.StrictMode>
	</ChakraProvider>
);

function AppRoutes() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [authFailed, setAuthFailed] = useState(null);
  const toast = useToast();

  useEffect(() => {
    if (authFailed) {
      toast({
        title: "Server Down",
        description: "Please wait a few minutes. If the problem persists, contact support.",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: 'bottom-right',
      });
    }
  }, [authFailed, toast]);

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      setIsAuthenticated(false);
      return;
    }

    axios
      .get("https://api.beehiveproject.no/auth/currentuser", {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        localStorage.setItem("userData", JSON.stringify(response.data));
        setIsAuthenticated(true);
        setAuthFailed(false);
      })
      .catch((error) => {
        setIsAuthenticated(false);

        if (!error.response) {
          // Network error or server down
          setAuthFailed(true);
          

        } else if (error.response.status === 401) {
          // Unauthorized
        } else {
          console.error("Error:", error.response.status);
        }
      });
  }, []);

  if (isAuthenticated === null) {
    return (
      <Flex height="100vh" align="center" justify="center">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <Switch>
      <Route path="/auth">
        {isAuthenticated ? <Redirect to="/admin" /> : <AuthLayout />}
      </Route>
      <Route path="/admin">
        {isAuthenticated ? <AdminLayout /> : <Redirect to="/auth" />}
      </Route>
      <Route path="/rtl">
        {isAuthenticated ? <RtlLayout /> : <Redirect to="/auth" />}
      </Route>
      <Redirect from="/" to={isAuthenticated ? "/admin" : "/auth"} />
    </Switch>
  );
}
